import { HSeparator } from '@/components/separator';
import { Tag } from '@/components/tag';
import { AppDispatch } from '@/root/store';
import { FormatCurrency } from '@/routes/root';
import { ShowTransaction } from '@/services/transactions';
import { CalendarDaysIcon, MapPinIcon } from '@heroicons/react/24/solid';
import moment from 'moment';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

const Section: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
}) => {
  return <div className='flex flex-col gap-4'>{children}</div>;
};

const Row: React.FC<{ label: React.ReactNode; value: React.ReactNode }> = ({
  label,
  value,
}) => {
  return (
    <div className='flex flex-row items-start gap-2 text-sm'>
      <span className='flex-grow font-medium text-neutral-70'>{label}</span>
      {value}
    </div>
  );
};

export function OrgTransactionDetail() {
  const { id } = useParams();
  const dispatch: AppDispatch = useDispatch();

  const { transaction } = useSelector((state: any) => state.transaction);

  useEffect(() => {
    dispatch(ShowTransaction(id));
  }, [dispatch, id]);

  return (
    <>
      <h2 className='text-center text-lg font-medium'>Detail Transaksi</h2>
      <Section>
        <Row
          label='Status pembayaran'
          value={
            <Tag color={transaction.status.color}>
              {transaction.status.label}
            </Tag>
          }
        />
        <Row
          label='Tanggal transaksi'
          value={moment(transaction.date).format('LL')}
        />
      </Section>
      <HSeparator />
      <Section>
        <Row label='Pembeli' value={transaction.buyer.name} />
        <Row label='E-mail' value={transaction.buyer.email} />
        <Row label='No. Telepon' value={transaction.buyer.whatsapp} />
      </Section>
      <HSeparator />

      <div className='flex flex-row gap-6'>
        <img
          className='object-fit h-full w-36 flex-shrink-0 rounded-md'
          src={transaction.event.banner.fallback_url}
          srcSet={transaction.event.banner.srcset}
          alt={transaction.event.title}
        />
        <div className='flex flex-grow flex-col gap-6'>
          <h1 className='text-xl font-semibold'>{transaction.event.title}</h1>
          <div className='flex items-center gap-2'>
            <MapPinIcon className='w-[20px] shrink-0 grow-0 text-neutral-60' />
            <span className='max-line-1 h-[20px] w-[calc(80%)] shrink-0 text-sm font-medium'>
              {transaction.event.location.name}
            </span>
          </div>
          <div className='flex gap-2'>
            <div className='flex items-center gap-2'>
              <CalendarDaysIcon className='w-[20px] text-neutral-60' />
              <span className='text-sm font-medium'>
                {moment(transaction.event.start_at).format('LL')}
              </span>
            </div>
          </div>
        </div>
      </div>
      <HSeparator />
      <h1 className='text-2xl font-medium'>Rincian pembayaran</h1>
      <Section>
        <Row
          label={`🎫 ${transaction.ticket} (${transaction.quantity})`}
          value={
            <FormatCurrency
              amount={transaction.subtotal / transaction.quantity}
              currency={transaction.currency_code}
            />
          }
        />
        <Row label='Metode pembayaran' value={transaction.channel_name} />
        <Row
          label='Subtotal'
          value={
            <span className='font-medium text-danger'>
              <FormatCurrency
                amount={transaction.subtotal}
                currency={transaction.currency_code}
              />
            </span>
          }
        />
        <Row
          label='Potongan biaya admin'
          value={
            <span className='font-medium text-danger'>
              <FormatCurrency
                amount={transaction.admin_fee}
                currency={transaction.currency_code}
              />
            </span>
          }
        />
        <Row
          label='Potongan diskon voucher'
          value={
            <span className='font-medium text-danger'>
              <FormatCurrency
                amount={transaction.discount}
                currency={transaction.currency_code}
              />
            </span>
          }
        />
        <Row
          label='Total'
          value={
            <span className='font-medium text-danger'>
              <FormatCurrency
                amount={transaction.total}
                currency={transaction.currency_code}
              />
            </span>
          }
        />
        <HSeparator />
        <Row
          label={
            <span className='text-base font-medium text-neutral-100'>
              Subtotal
            </span>
          }
          value={
            <span className='text-base font-medium text-danger'>
              <FormatCurrency
                amount={transaction.subtotal}
                currency={transaction.currency_code}
              />
            </span>
          }
        />
      </Section>
    </>
  );
}
